import defiantModule from 'defiant.js/dist/defiant';

const tgg = window.tgg;
// There is an issue with the NodeJS bundled version, which causes runtime issues
// in the browser.
const defiant = window.defiant || defiantModule;

const snapshotsReadyPromise = new Promise((resolve) => {
    let guidelinesSnapshot;
    let topicSnapshot;
    let snapshotsCompleted = 0;

    console.time("Created Enhanced Snapshots");

    const checkSnapshotsReady = () => {
        snapshotsCompleted++;
        if (snapshotsCompleted === 2) {
            console.timeEnd("Created Enhanced Snapshots");
            resolve({ guidelinesSnapshot, topicSnapshot });
        }
    };

    defiant.getSnapshot(tgg?.guidelines, (gsnapshot) => {
        guidelinesSnapshot = gsnapshot;
        checkSnapshotsReady();
    });

    defiant.getSnapshot(tgg?.topics, (tsnapshot) => {
        topicSnapshot = tsnapshot;
        checkSnapshotsReady();
    });
});

const getSnapshots = () => snapshotsReadyPromise;
export default getSnapshots
